import React, { useState, useEffect } from "react";
import {
  Space,
  Select,
  Popconfirm,
  Tooltip,
  Button,
} from "antd";
import { audioMessage as message } from '../Common/Notifications/audioMessage';
import { TrainingAPI } from "../../api/TrainingAPI";

const { Option } = Select;

export const DrillMergeTable = () => {
  const [drills, setDrills] = useState([]);
  const [drillIds, setDrillIds] = useState([]);
  const [toRemoveSelected, setToRemoveSelected] = useState(undefined);
  const [toRemoveId, setToRemoveId] = useState(undefined);
  const [toAssignSelected, setToAssignSelected] = useState(undefined);
  const [toAssignId, setToAssignId] = useState(undefined);
  const trainingAPI = new TrainingAPI();

  useEffect(() => {
    getDrills();
  }, []);

  const getDrills = () => {
    trainingAPI.getDrills().then((data) => {
      setDrills(data.map((drill, i) => drill.name));
      setDrillIds(data.map((drill, i) => drill.drill_id));
    });
  };

  const onToAssignChange = (val) => {
    setToAssignSelected(drills[val]);
    setToAssignId(drillIds[val]);
  };

  const onToRemoveChange = (val) => {
    setToRemoveSelected(drills[val]);
    setToRemoveId(drillIds[val]);
  };

  const onSubmit = () => {
    trainingAPI
      .mergeDrills(toRemoveId, toAssignId)
      .then((data) => {
        message.success("Drills merged");
        setToRemoveSelected(undefined);
        setToRemoveId(undefined);
        setToAssignSelected(undefined);
        setToAssignId(undefined);
        getDrills();
      })
      .catch((e) => {
        console.log(e.response);
        if (e.response.status === 400) {
          message.error(e.response.data);
        } else {
          message.error("Error merging drills");
        }
      });
  };

  return (
    <>
      <div className="report-injury-header2">Replace Drills</div>
      <br />
      <Space>
        <div className="injury-item">
          <Select
            showSearch
            style={{ width: 200 }}
            placeholder="Drill To Replace"
            value={toRemoveSelected}
            onChange={onToRemoveChange}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {drills.length !== 0 ? (
              drills.map((drill, i) => (
                <Option key={i} value={i}>
                  {drill}
                </Option>
              ))
            ) : (
              <></>
            )}
          </Select>
        </div>
        <div className="injury-item">
          <Select
            showSearch
            style={{ width: 200 }}
            placeholder="Drill to Keep"
            value={toAssignSelected}
            onChange={onToAssignChange}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {drills.length !== 0 ? (
              drills.map((drill, i) => (
                <Option key={i} value={i}>
                  {drill}
                </Option>
              ))
            ) : (
              <></>
            )}
          </Select>
        </div>
        <Popconfirm
          title="Are you sure you want to replace these drills?"
          onConfirm={onSubmit}
          okText="Yes"
          cancelText="No"
        >
          {toRemoveSelected === undefined || toAssignSelected === undefined ? (
            <Tooltip title="Not all fields selected">
              <Button type="primary" disabled>
                Replace Drills
              </Button>
            </Tooltip>
          ) : (
            <Button type="primary">Replace Drills</Button>
          )}
        </Popconfirm>
      </Space>
    </>
  );
};
